import mixpanel from 'mixpanel-browser';

// @ts-ignore
const nuxtMixpanel: Plugin = (ctx, inject) => {
  const { mixpanelToken, mixpanelEndpoint } = ctx.env;
  mixpanel.init(mixpanelToken);
  mixpanel.set_config({
    api_host: mixpanelEndpoint,
  });
  inject('mixpanel', mixpanel);
};

export default nuxtMixpanel;
